import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { fetchFrauds } from "../../../actions/masters/fraudActions";
import Spinner from "../../Spinner";

class FraudTypeList extends Component {
  componentDidMount() {
    this.props.fetchFrauds();
  }

  renderList() {
    return this.props.fraudType.map((fraud) => {
      return (
        <tr key={fraud.id}>
          <td>{fraud.name}</td>
          <td>{fraud.activeFlag === "Y" ? "Active" : "InActive"}</td>
          {this.props.user.role === "Admin" ? (
            <td>
              <Link to={`/masters/FraudType/Edit/${fraud.id}`}>
                <span>
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </span>
              </Link>
            </td>
          ) : (
            <td></td>
          )}
        </tr>
      );
    });
  }

  render() {
    return (
      <div>
        {this.props.fraudType.length > 0 ? (
          <div className="BodyInContainer">
            <div className="d-block clearfix">
              <div className="Header-Content float-start">
                <h3 className="pageMainTitle">Fraud Type Master</h3>
              </div>
              {/* {this.props.user.role === "Admin" ? (
                <div className="float-end mt-15">
                  <Link className="btnMain" to="/masters/FraudType/create">
                    Add
                  </Link>
                </div>
              ) : (
                ""
              )} */}
            </div>
            <div className="mainBodyCard pt-0">
              <table className="table table-hover tableStyle1 fraudTypeTable">
                <thead>
                  <tr>
                    <td>Fraud Type</td>
                    <td>Active/Inactive</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>{this.renderList()}</tbody>
              </table>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fraudType: Object.values(state.fraudType),
    user: state.login,
  };
};

export default connect(mapStateToProps, { fetchFrauds })(FraudTypeList);
